import { DEFAULT_LOCALE } from '@/models/localization.model';
import { IOrderRegions } from '@/models/orders.model';

export const getRegionSelectConfig = (
  regionsOptions:
    | {
        label: string;
        value: string;
      }[]
    | undefined,
  region?: IOrderRegions | null,
) => {
  return regionsOptions?.some((item) => item.value === region?.id) || !region
    ? regionsOptions
    : [
        {
          label: region?.locale?.[DEFAULT_LOCALE].name ?? '',
          value: region?.id ?? '',
        },
        ...(regionsOptions ?? []),
      ];
};
